// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__23mq8","errorLogs":"styles_errorLogs__2Kcq-"};